<template>
  <div>
    <article class="checkin-list-item" ref="checkinItem">
      <header class="checkin-list-item__header">
        <div class="d-flex justify-content-between align-items-start">
          <a href="#" class="d-block w-100" @click.prevent="emitOpenCheckinDetail(true)">
            <h2 class="checkin-list-item__title">{{ checkin.pica_service.event_name }}</h2>
            <div class="d-flex align-items-center checkin-list-item__sub-header">
              <div>
              <span class="checkin-list-item__status-icon" v-if="!checkin.pica_service.is_tagging_completed"></span>
                </div>
              <h6 class="checkin-list-item__sub-title">{{ checkin.pica_service.event_subtitle }}</h6>
            </div>
          </a>

          <!-- CONTEXT MENU -->
          <checkin-menu
              dropleft
              :checkin="checkin"
              :event-name="checkin.pica_service.event_name"
              :show-anonymize="false"
              icon-class="text-secondary"
              @remove-album="$emit('item-remove')"
              @anonymize-album="$emit('anonymize-album', $event)"
              @show-qr-picacode="$emit('show-qr-picacode')"
              @download-album="$emit('download-album')"/>
        </div>
      </header>

      <a href="#" @click.prevent="emitOpenCheckinDetail(false)">
        <section class="checkin-list-item__photos" :class="{'has-more-photos': morePhotosCount > 1}"
                 v-if="photosLoaded">
          <template v-if="checkin.user_cta===userCTA.NONE">
            <template v-if="photos.length === 0">
              <div class="checkin-list-item__photo-item" v-for="index in 5" :key="index"
                   :data-index="index">
                <div class="checkin-list-item__photo-item__img"></div>
              </div>
            </template>
            <template v-else>
              <div class="checkin-list-item__photo-item" v-for="(photo, index) in photosPadded" :key="index">
                <img v-lazy="photo.image_url" class="checkin-list-item__photo-item__img"
                   v-if="photo && photo.image_url"/>
                <div class="checkin-list-item__photo-item__img" v-else></div>
                <div class="badge" v-if="(morePhotosCount > 1 && index === photosPadded.length - 1)">
                  +{{ morePhotosCount }}
                </div>
              </div>

              <InfoMediaAvailableList :available-to="mediaAvailableTo" v-if="mediaAvailableTo"/>
              <InfoHdAvailableList :hd-available-to="hdAvailableTo" v-else-if="hdAvailableTo"/>
            </template>
          </template>
          <div class="checkin-list-item__photos__none" v-else-if="checkin.user_cta === userCTA.SUPPORT">
            <div class="message-list text-center">
              <h6 class="checkin-list-item__photos__none__title mb-3" v-html="$t('pages.checkins.no_photo_found_support')">
              </h6>
            </div>
          </div>
          <div class="checkin-list-item__photos__none" v-else-if="checkin.user_cta === userCTA.FACE_CHECKIN">
            <div class="message-list text-center">
              <h6 class="checkin-list-item__photos__none__title mb-3">{{ $t('pages.checkins.no_photo_found') }}</h6>
              <div>
                <b-button class="user-cta__action has-icon" variant="primary">
                     <Icon name="faceId" width="26"/>
                      {{ $t('pages.checkins.search_with_selfie') }}</b-button>
              </div>
            </div>
          </div>
          <div class="checkin-list-item__photos__none" v-else>
            <div class="text-center">
              <h4 class="checkin-list-item__photos__none__title">
                {{ $t('pages.checkins_list.photos_available_soon_title') }}</h4>
              <h5 class="checkin-list-item__photos__none__desc mt-2 text-secondary">
                {{ $t('pages.checkins_list.photos_available_soon_message') }}
              </h5>
            </div>
          </div>
        </section>

        <section class="checkin-list-item__photos" v-else>
          <div class="checkin-list-item__photo-item" v-for="index in 5" :key="index">
            <div class="checkin-list-item__photo-item__img"></div>
          </div>
        </section>
      </a>
      <div class="checkin-list-item__footer" v-if="showAnonymizationSatus">
        <div class="checkin-list-item__anonymize d-flex align-items-center">
          <span class="checkin-list-item__anonymize--icon"></span>
          <span class="checkin-list-item__anonymize--text">{{
              $t('pages.checkins_detail.anonymous_mode_on')
            }}</span>
        </div>
      </div>
    </article>

  </div>
</template>


<script>
import {getContactUrl} from "@/utils";
import {ANONYMIZATION_STATUS} from "@/components/ModalAnonymizeCheckin.vue";
import CheckinMenu from "@/domain/core/CheckinMenu.vue";
import {userCTA} from "@/consts";
import {mapActions} from "vuex";
import {IntersectionObserverHelper} from "@/domain/core/helper/IntersectionObserverHelper";
import InfoHdAvailableList from "@/domain/checkin/InfoHdAvailableList.vue";
import InfoMediaAvailableList from "@/domain/checkin/InfoMediaAvailableList.vue";

export default {

  props: {
    checkin: {
      type: Object,
      required: true
    }
  },

  components: {
    InfoMediaAvailableList,
    InfoHdAvailableList,
    CheckinMenu
  },
  created() {
    this.ANONYMIZATION_STATUS = ANONYMIZATION_STATUS
  },
  data() {
    return {
      loading: true,
      openFaceRecognitionModalAfterClick: false
    }
  },

  mounted() {
    this.observer = new IntersectionObserverHelper(this.$refs.checkinItem,
        {threshold: .2},
        (entry) => {
          if (!this.loading) return
          if (entry.intersectionRatio > .2 && !this.checkin.loaded) {
            this.loadCheckinPhotos()
          }
        })
  },

  computed: {
    userCTA() {
      return userCTA
    },
    showAnonymizationSatus() {
      return this.checkin.anonymize_status !== this.ANONYMIZATION_STATUS.unavailable &&
          this.checkin.anonymize_status === this.ANONYMIZATION_STATUS.completed
    },
    photosLoaded() {
      return this.checkin.loaded
    },
    photos() {
      return this.checkin.photos.results || []
    },
    photosPadded() {
      return Array.from({...this.photos, length: 5})
    },
    photosCount() {
      return this.checkin.photos.pagination.total
    },
    morePhotosCount() {
      const displayed_preview_photos = 4
      return this.photosCount - displayed_preview_photos
    },
    isTwelveHoursOverEventEnd() {
      let twelveHoursEventEnd = new Date(this.checkin.pica_service.event_end_at)
      twelveHoursEventEnd.setHours(twelveHoursEventEnd.getHours() + 12)
      return new Date() > twelveHoursEventEnd
    },
    openFaceRecognitionAfterClick() {
      return this.checkin.user_cta === userCTA.FACE_CHECKIN
    },
    contactUrl() {
      return getContactUrl(`${this.checkin.pica_service.event_name} | ${this.checkin.picacode}`)
    },
    hdAvailableTo() {
      return this.checkin.pica_service.hd_available_to
    },
    mediaAvailableTo() {
      return this.checkin.media_available_to
    }
  },

  methods: {
    ...mapActions('digitalItems', ['getCheckinPhotos']),

    async loadCheckinPhotos() {
      this.loading = true
      await this.getCheckinPhotos({
        checkinId: this.checkin.id, params: {
          "page": 1, "page_size": 5
        }
      })
      this.loading = false
    },

    emitOpenCheckinDetail(forceCheckDetail) {
      if (this.checkin.user_cta === userCTA.SUPPORT && !forceCheckDetail) {
        window.open(this.contactUrl)
      } else {
        this.$emit('item-clicked', {
          openFaceReconition: this.openFaceRecognitionAfterClick && !forceCheckDetail,
          checkinId: this.checkin.id,
          picacode: this.checkin.picacode,
          picaServiceId: this.checkin.pica_service.id
        })
      }
    }
  },
  beforeDestroy() {
    this.observer.disconnect()
  }
}
</script>
